import { useMatches } from 'react-router';

import type { Rota, Subrota } from './rotas';

/** O que cada rota carrega no `handle` para que os shells se orientem. */
export interface HandleDeRota {
    rota: Rota;
    subrota?: Subrota;
}

/**
 * A rota montada mais funda. Os shells precisam saber em que módulo estão para
 * marcar a navegação e montar o caminho — e ler isso da URL com expressão
 * regular daria uma segunda fonte de verdade, que sairia de sincronia.
 */
export function useRotaAtual(): HandleDeRota | undefined {
    const matches = useMatches();
    for (let i = matches.length - 1; i >= 0; i -= 1) {
        const handle = matches[i]?.handle as HandleDeRota | undefined;
        if (handle?.rota) return handle;
    }
    return undefined;
}
